import { AsyncMetaState, createScopedReducer } from '@mews/framework';
import { META_STATE_SUCCEEDED } from '@mews-commander/legacy-entities/src/constants';
import { createEntityAsyncMetaHandlers } from '@mews-commander/legacy-entities/src/ducks/utils';
import { ACCOUNT_NOTES_INIT_FAILED, ACCOUNT_NOTES_INIT_STARTED, ACCOUNT_NOTES_INIT_SUCCEEDED } from '../actionTypes';

export interface AccountNotesState {
    meta: AsyncMetaState;
}

export const initialState: AccountNotesState = {
    ...META_STATE_SUCCEEDED,
};

export default createScopedReducer(initialState, {
    ...createEntityAsyncMetaHandlers({
        STARTED: ACCOUNT_NOTES_INIT_STARTED,
        SUCCEEDED: ACCOUNT_NOTES_INIT_SUCCEEDED,
        FAILED: ACCOUNT_NOTES_INIT_FAILED,
    }),
});
